import React from "react";
import Footer from "../../common/Footer/Footer";
import Header from '../../common/Header/Header';
import FAQ from "../../components/FAQ/FAQ";
import SEO from "../../components/SEO/SEO";

const FAQPage = () => {
  return (
    <div>
      <SEO
        title="Frequently Asked Questions"
        description="Find answers to common questions about online therapy, how sessions work, pricing, privacy and more on MindTherapy Counselling."
        canonical="https://mindtherapycounselling.com/faq"
      />
      <Header />
      <FAQ />
      <Footer />
    </div>
  );
};

export default FAQPage;